import * as React from 'react';
import { injectGlobal } from 'styled-components';

injectGlobal`
@-webkit-keyframes kf_el_F85Rcy7KKrN_an_5k3_54w_Q{
    0%{
        opacity: 0;
    }
    2.22%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@keyframes kf_el_F85Rcy7KKrN_an_5k3_54w_Q{
    0%{
        opacity: 0;
    }
    2.22%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@-webkit-keyframes kf_el_pXeEy60fNMO_an_Bb8OxRjf6{
    0%{
        opacity: 0;
    }
    4.44%{
        opacity: 0;
    }
    6.67%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@keyframes kf_el_pXeEy60fNMO_an_Bb8OxRjf6{
    0%{
        opacity: 0;
    }
    4.44%{
        opacity: 0;
    }
    6.67%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@-webkit-keyframes kf_el_djkdAkKoWjd_an_70uWJDznl{
    0%{
        opacity: 0;
    }
    11.11%{
        opacity: 0;
    }
    13.33%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@keyframes kf_el_djkdAkKoWjd_an_70uWJDznl{
    0%{
        opacity: 0;
    }
    11.11%{
        opacity: 0;
    }
    13.33%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@-webkit-keyframes kf_el_ePehtqZKkF2_an_QwL_iTEqL{
    0%{
        opacity: 0;
    }
    15.56%{
        opacity: 0;
    }
    17.78%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@keyframes kf_el_ePehtqZKkF2_an_QwL_iTEqL{
    0%{
        opacity: 0;
    }
    15.56%{
        opacity: 0;
    }
    17.78%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@-webkit-keyframes kf_el_M4JKcPN5muE_an_qsxumHAu9{
    0%{
        opacity: 0;
    }
    20%{
        opacity: 0;
    }
    22.22%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@keyframes kf_el_M4JKcPN5muE_an_qsxumHAu9{
    0%{
        opacity: 0;
    }
    20%{
        opacity: 0;
    }
    22.22%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@-webkit-keyframes kf_el_GIYiIF7iIse_an_Ew0ZOhgOd{
    0%{
        opacity: 0;
    }
    24.44%{
        opacity: 0;
    }
    26.67%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@keyframes kf_el_GIYiIF7iIse_an_Ew0ZOhgOd{
    0%{
        opacity: 0;
    }
    24.44%{
        opacity: 0;
    }
    26.67%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@-webkit-keyframes kf_el_-HQKXn1BVqD_an_pIbsBMEuI{
    0%{
        opacity: 0;
    }
    28.89%{
        opacity: 0;
    }
    31.11%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@keyframes kf_el_-HQKXn1BVqD_an_pIbsBMEuI{
    0%{
        opacity: 0;
    }
    28.89%{
        opacity: 0;
    }
    31.11%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@-webkit-keyframes kf_el_ciMkrvowX3d_an_wEV_Zwb4u{
    0%{
        opacity: 0;
    }
    33.33%{
        opacity: 0;
    }
    35.56%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@keyframes kf_el_ciMkrvowX3d_an_wEV_Zwb4u{
    0%{
        opacity: 0;
    }
    33.33%{
        opacity: 0;
    }
    35.56%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@-webkit-keyframes kf_el_vdpgPd2MrFF_an_1Shua6TXh{
    0%{
        opacity: 0;
    }
    37.78%{
        opacity: 0;
    }
    40%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@keyframes kf_el_vdpgPd2MrFF_an_1Shua6TXh{
    0%{
        opacity: 0;
    }
    37.78%{
        opacity: 0;
    }
    40%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@-webkit-keyframes kf_el_GGQN3_BuYi5_an_8EzinJDJG{
    0%{
        opacity: 0;
    }
    42.22%{
        opacity: 0;
    }
    44.44%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@keyframes kf_el_GGQN3_BuYi5_an_8EzinJDJG{
    0%{
        opacity: 0;
    }
    42.22%{
        opacity: 0;
    }
    44.44%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@-webkit-keyframes kf_el_-ugChuB7G9E_an_i36PeAWrI{
    0%{
        opacity: 0;
    }
    46.67%{
        opacity: 0;
    }
    48.89%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@keyframes kf_el_-ugChuB7G9E_an_i36PeAWrI{
    0%{
        opacity: 0;
    }
    46.67%{
        opacity: 0;
    }
    48.89%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@-webkit-keyframes kf_el_pps5G3oW8Dp_an_tfiLYslLU{
    0%{
        opacity: 0;
    }
    51.11%{
        opacity: 0;
    }
    53.33%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@keyframes kf_el_pps5G3oW8Dp_an_tfiLYslLU{
    0%{
        opacity: 0;
    }
    51.11%{
        opacity: 0;
    }
    53.33%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@-webkit-keyframes kf_el_CjIte0xzZl5_an_44x8_vrYk{
    0%{
        opacity: 0;
    }
    55.56%{
        opacity: 0;
    }
    57.78%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@keyframes kf_el_CjIte0xzZl5_an_44x8_vrYk{
    0%{
        opacity: 0;
    }
    55.56%{
        opacity: 0;
    }
    57.78%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@-webkit-keyframes kf_el_vFy43RLBRC4_an_TSRgThk-R{
    0%{
        opacity: 0;
    }
    60%{
        opacity: 0;
    }
    62.22%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@keyframes kf_el_vFy43RLBRC4_an_TSRgThk-R{
    0%{
        opacity: 0;
    }
    60%{
        opacity: 0;
    }
    62.22%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@-webkit-keyframes kf_el_pWWQGhAiDr5_an_-tGd47JB9{
    0%{
        opacity: 0;
    }
    64.44%{
        opacity: 0;
    }
    66.67%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@keyframes kf_el_pWWQGhAiDr5_an_-tGd47JB9{
    0%{
        opacity: 0;
    }
    64.44%{
        opacity: 0;
    }
    66.67%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@-webkit-keyframes kf_el_Q1y0Mpjw1HR_an_Mh-zD9AQD{
    0%{
        opacity: 0;
    }
    68.89%{
        opacity: 0;
    }
    71.11%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@keyframes kf_el_Q1y0Mpjw1HR_an_Mh-zD9AQD{
    0%{
        opacity: 0;
    }
    68.89%{
        opacity: 0;
    }
    71.11%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@-webkit-keyframes kf_el_zPQzckSY4N_an_ukBjab1Vp{
    0%{
        opacity: 0;
    }
    73.33%{
        opacity: 0;
    }
    75.56%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@keyframes kf_el_zPQzckSY4N_an_ukBjab1Vp{
    0%{
        opacity: 0;
    }
    73.33%{
        opacity: 0;
    }
    75.56%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@-webkit-keyframes kf_el_dZOFYlQdPM_an_-tU_r2MjS{
    0%{
        opacity: 0;
    }
    77.78%{
        opacity: 0;
    }
    80%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@keyframes kf_el_dZOFYlQdPM_an_-tU_r2MjS{
    0%{
        opacity: 0;
    }
    77.78%{
        opacity: 0;
    }
    80%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@-webkit-keyframes kf_el_ZblYCgLfME_an_GUPeSNb9F{
    0%{
        opacity: 0;
    }
    82.22%{
        opacity: 0;
    }
    84.44%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
@keyframes kf_el_ZblYCgLfME_an_GUPeSNb9F{
    0%{
        opacity: 0;
    }
    82.22%{
        opacity: 0;
    }
    84.44%{
        opacity: 1;
    }
    100%{
        opacity: 1;
    }
}
#el_qT5mH7qBX *{
    -webkit-animation-duration: 1.5s;
    animation-duration: 1.5s;
    -webkit-animation-iteration-count: 1;
    animation-iteration-count: 1;
    -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
    animation-timing-function: cubic-bezier(0, 0, 1, 1);
}
#el_Ffsp1pFFAE{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_WV7ciXGtKI{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_VCQAAL33IT{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_6IUoYJsTiu{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_Um5icXbUOX{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_1st6rutqht{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_PAaQtlY8iz{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_OJ1j9Cpekr{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_DfobBtBEf9{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_08njgYNQLy{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_0PH24rdpBe{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_3yl9NfWHQ0{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_05kFatetoHO{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_c9zQVp7vrsP{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_uwnON0vpuqH{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_VzWu6OVhy9Z{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_Pw6JNw5UaKN{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_rh_iVV52hvM{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_SFT6u_AabW-{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_OQ9kJTc8a3c{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_KebrT7vPDSq{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_Nl7MPzofApJ{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_QNBsnXS-9MN{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_UW58TrQjNUB{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_V1XKDCs7Y1w{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_sppwRz2Vw3n{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_r9eX6krpCnm{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_Bh5f82mbhhK{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_6nzqrJXYm6_{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_EXmoVUjJthl{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_owlFqmqCm-5{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_qCXjfTIqryw{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_BxvkUEQQDcy{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_HBKdZifKVkK{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_Vagk-9u-CHZ{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_QNiNDq9JdJ5{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_6NXBid1Dhgd{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_ppui91L-U9j{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_hxaLYRwU7uL{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_ZjHfVGfJ4SQ{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_nQHGPd09Y34{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_o4nSIhJdezA{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_53IxYoalfe6{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_lv5mZDRJcmd{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_VBQonMOoH67{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_ZLmcW48Cotn{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_LR3FmyeloCK{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_n__IR7h8ue9{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_dd6wgjE--m9{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_Fa33R_nQrct{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_-PDbKUzL7pi{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_4H7NClsm_iX{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_y9ccQ7qwds_{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_TAxKOOZYl3Q{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_MOuUkeVja9v{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_C8D2acPIqzZ{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_pWfYtK_vB-p{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_pyzhoQ8dwKj{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_eMews-3FU20{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_XsP2I8GNRmR{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_rYcgw868u70{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_ic8mx7njq-r{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_TD1oYgAx3v6{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_BCtHBLq0YRS{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_wGjLLFdaFPo{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_MXZjAlvGuBh{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_2mM6E_cKkIk{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_Eg5eL87f3Gz{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_nreGhzvIBWT{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_ukIEkZwJskX{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_iG4vGgjgmRl{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_gPgCVIL9Ijy{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_9k0qwqCrWTs{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_B5zhfNkTVew{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_2MQl81jm3s5{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_dXnYDrUfbGB{
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #F8AB08;
}
#el_ZblYCgLfME{
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    opacity: 0;
    -webkit-animation-name: kf_el_ZblYCgLfME_an_GUPeSNb9F;
    animation-name: kf_el_ZblYCgLfME_an_GUPeSNb9F;
    -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
    animation-timing-function: cubic-bezier(0, 0, 1, 1);
}
#el_dZOFYlQdPM{
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    opacity: 0;
    -webkit-animation-name: kf_el_dZOFYlQdPM_an_-tU_r2MjS;
    animation-name: kf_el_dZOFYlQdPM_an_-tU_r2MjS;
    -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
    animation-timing-function: cubic-bezier(0, 0, 1, 1);
}
#el_zPQzckSY4N{
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    opacity: 0;
    -webkit-animation-name: kf_el_zPQzckSY4N_an_ukBjab1Vp;
    animation-name: kf_el_zPQzckSY4N_an_ukBjab1Vp;
    -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
    animation-timing-function: cubic-bezier(0, 0, 1, 1);
}
#el_Q1y0Mpjw1HR{
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    opacity: 0;
    -webkit-animation-name: kf_el_Q1y0Mpjw1HR_an_Mh-zD9AQD;
    animation-name: kf_el_Q1y0Mpjw1HR_an_Mh-zD9AQD;
    -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
    animation-timing-function: cubic-bezier(0, 0, 1, 1);
}
#el_pWWQGhAiDr5{
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    opacity: 0;
    -webkit-animation-name: kf_el_pWWQGhAiDr5_an_-tGd47JB9;
    animation-name: kf_el_pWWQGhAiDr5_an_-tGd47JB9;
    -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
    animation-timing-function: cubic-bezier(0, 0, 1, 1);
}
#el_vFy43RLBRC4{
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    opacity: 0;
    -webkit-animation-name: kf_el_vFy43RLBRC4_an_TSRgThk-R;
    animation-name: kf_el_vFy43RLBRC4_an_TSRgThk-R;
    -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
    animation-timing-function: cubic-bezier(0, 0, 1, 1);
}
#el_CjIte0xzZl5{
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    opacity: 0;
    -webkit-animation-name: kf_el_CjIte0xzZl5_an_44x8_vrYk;
    animation-name: kf_el_CjIte0xzZl5_an_44x8_vrYk;
    -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
    animation-timing-function: cubic-bezier(0, 0, 1, 1);
}
#el_pps5G3oW8Dp{
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    opacity: 0;
    -webkit-animation-name: kf_el_pps5G3oW8Dp_an_tfiLYslLU;
    animation-name: kf_el_pps5G3oW8Dp_an_tfiLYslLU;
    -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
    animation-timing-function: cubic-bezier(0, 0, 1, 1);
}
#el_-ugChuB7G9E{
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    opacity: 0;
    -webkit-animation-name: kf_el_-ugChuB7G9E_an_i36PeAWrI;
    animation-name: kf_el_-ugChuB7G9E_an_i36PeAWrI;
    -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
    animation-timing-function: cubic-bezier(0, 0, 1, 1);
}
#el_GGQN3_BuYi5{
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    opacity: 0;
    -webkit-animation-name: kf_el_GGQN3_BuYi5_an_8EzinJDJG;
    animation-name: kf_el_GGQN3_BuYi5_an_8EzinJDJG;
    -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
    animation-timing-function: cubic-bezier(0, 0, 1, 1);
}
#el_vdpgPd2MrFF{
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    opacity: 0;
    -webkit-animation-name: kf_el_vdpgPd2MrFF_an_1Shua6TXh;
    animation-name: kf_el_vdpgPd2MrFF_an_1Shua6TXh;
    -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
    animation-timing-function: cubic-bezier(0, 0, 1, 1);
}
#el_ciMkrvowX3d{
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    opacity: 0;
    -webkit-animation-name: kf_el_ciMkrvowX3d_an_wEV_Zwb4u;
    animation-name: kf_el_ciMkrvowX3d_an_wEV_Zwb4u;
    -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
    animation-timing-function: cubic-bezier(0, 0, 1, 1);
}
#el_-HQKXn1BVqD{
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    opacity: 0;
    -webkit-animation-name: kf_el_-HQKXn1BVqD_an_pIbsBMEuI;
    animation-name: kf_el_-HQKXn1BVqD_an_pIbsBMEuI;
    -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
    animation-timing-function: cubic-bezier(0, 0, 1, 1);
}
#el_GIYiIF7iIse{
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    opacity: 0;
    -webkit-animation-name: kf_el_GIYiIF7iIse_an_Ew0ZOhgOd;
    animation-name: kf_el_GIYiIF7iIse_an_Ew0ZOhgOd;
    -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
    animation-timing-function: cubic-bezier(0, 0, 1, 1);
}
#el_M4JKcPN5muE{
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    opacity: 0;
    -webkit-animation-name: kf_el_M4JKcPN5muE_an_qsxumHAu9;
    animation-name: kf_el_M4JKcPN5muE_an_qsxumHAu9;
    -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
    animation-timing-function: cubic-bezier(0, 0, 1, 1);
}
#el_ePehtqZKkF2{
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    opacity: 0;
    -webkit-animation-name: kf_el_ePehtqZKkF2_an_QwL_iTEqL;
    animation-name: kf_el_ePehtqZKkF2_an_QwL_iTEqL;
    -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
    animation-timing-function: cubic-bezier(0, 0, 1, 1);
}
#el_djkdAkKoWjd{
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    opacity: 0;
    -webkit-animation-name: kf_el_djkdAkKoWjd_an_70uWJDznl;
    animation-name: kf_el_djkdAkKoWjd_an_70uWJDznl;
    -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
    animation-timing-function: cubic-bezier(0, 0, 1, 1);
}
#el_pXeEy60fNMO{
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    opacity: 0;
    -webkit-animation-name: kf_el_pXeEy60fNMO_an_Bb8OxRjf6;
    animation-name: kf_el_pXeEy60fNMO_an_Bb8OxRjf6;
    -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
    animation-timing-function: cubic-bezier(0, 0, 1, 1);
}
#el_F85Rcy7KKrN{
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    opacity: 0;
    -webkit-animation-name: kf_el_F85Rcy7KKrN_an_5k3_54w_Q;
    animation-name: kf_el_F85Rcy7KKrN_an_5k3_54w_Q;
    -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
    animation-timing-function: cubic-bezier(0, 0, 1, 1);
}


`;

export class RaySVG extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 820 440" id="el_qT5mH7qBX">
        <g id="el_ZblYCgLfME">
          <path
            d="M64.9,11c-4.6,0-8.4,3.8-8.4,8.4c0,4.6,3.8,8.4,8.4,8.4c4.6,0,8.4-3.8,8.4-8.4C73.3,14.8,69.5,11,64.9,11z M64.9,23.8c-2.4,0-4.4-2-4.4-4.4c0-2.4,2-4.4,4.4-4.4c2.4,0,4.4,2,4.4,4.4C69.3,21.8,67.3,23.8,64.9,23.8z"
            id="el_Ffsp1pFFAE"
          />
          <path
            d="M146.5,11c-4.6,0-8.4,3.8-8.4,8.4c0,4.6,3.8,8.4,8.4,8.4c4.6,0,8.4-3.8,8.4-8.4C154.9,14.8,151.1,11,146.5,11z M146.5,23.8c-2.4,0-4.4-2-4.4-4.4c0-2.4,2-4.4,4.4-4.4c2.4,0,4.4,2,4.4,4.4C150.9,21.8,148.9,23.8,146.5,23.8z"
            id="el_WV7ciXGtKI"
          />
          <path
            d="M105.7,11c-4.6,0-8.4,3.8-8.4,8.4c0,4.6,3.8,8.4,8.4,8.4c4.6,0,8.4-3.8,8.4-8.4C114.1,14.8,110.3,11,105.7,11z M105.7,23.8c-2.4,0-4.4-2-4.4-4.4c0-2.4,2-4.4,4.4-4.4c2.4,0,4.4,2,4.4,4.4C110.1,21.8,108.1,23.8,105.7,23.8z"
            id="el_VCQAAL33IT"
          />
          <path
            d="M24.1,11c-4.6,0-8.4,3.8-8.4,8.4c0,4.6,3.8,8.4,8.4,8.4c4.6,0,8.4-3.8,8.4-8.4C32.5,14.8,28.8,11,24.1,11z M24.1,23.8c-2.4,0-4.4-2-4.4-4.4c0-2.4,2-4.4,4.4-4.4c2.4,0,4.4,2,4.4,4.4C28.5,21.8,26.6,23.8,24.1,23.8z"
            id="el_6IUoYJsTiu"
          />
        </g>
        <g id="el_dZOFYlQdPM">
          <path
            d="M118.8,70.7c-0.8-4.6-5.2-7.6-9.7-6.8c-4.6,0.8-7.6,5.2-6.8,9.7c0.8,4.6,5.2,7.6,9.7,6.8 C116.5,79.6,119.6,75.3,118.8,70.7z M111.3,76.5c-2.4,0.4-4.7-1.2-5.1-3.6c-0.4-2.4,1.2-4.7,3.6-5.1c2.4-0.4,4.7,1.2,5.1,3.6 C115.2,73.8,113.6,76.1,111.3,76.5z"
            id="el_Um5icXbUOX"
          />
          <path
            d="M158.7,63.5c-0.8-4.6-5.2-7.6-9.7-6.8c-4.6,0.8-7.6,5.2-6.8,9.7c0.8,4.6,5.2,7.6,9.7,6.8 C156.5,72.4,159.5,68.1,158.7,63.5z M151.2,69.3c-2.4,0.4-4.7-1.2-5.1-3.6c-0.4-2.4,1.2-4.7,3.6-5.1c2.4-0.4,4.7,1.2,5.1,3.6 C155.2,66.6,153.6,68.9,151.2,69.3z"
            id="el_1st6rutqht"
          />
          <path
            d="M78.8,77.9c-0.8-4.6-5.2-7.6-9.7-6.8c-4.6,0.8-7.6,5.2-6.8,9.7c0.8,4.6,5.2,7.6,9.7,6.8 C76.5,86.8,79.6,82.5,78.8,77.9z M71.3,83.7c-2.4,0.4-4.7-1.2-5.1-3.6c-0.4-2.4,1.2-4.7,3.6-5.1c2.4-0.4,4.7,1.2,5.1,3.6 C75.3,81,73.7,83.3,71.3,83.7z"
            id="el_PAaQtlY8iz"
          />
          <path
            d="M38.8,85.1c-0.8-4.6-5.2-7.6-9.7-6.8c-4.6,0.8-7.6,5.2-6.8,9.7c0.8,4.6,5.2,7.6,9.7,6.8 C36.6,94,39.6,89.7,38.8,85.1z M31.3,90.9c-2.4,0.4-4.7-1.2-5.1-3.6c-0.4-2.4,1.2-4.7,3.6-5.1c2.4-0.4,4.7,1.2,5.1,3.6 C35.3,88.2,33.7,90.5,31.3,90.9z"
            id="el_OJ1j9Cpekr"
          />
        </g>
        <g id="el_zPQzckSY4N">
          <path
            d="M132,120.5c-1.6-4.4-6.4-6.6-10.8-5c-4.4,1.6-6.6,6.4-5,10.8c1.6,4.4,6.4,6.6,10.8,5 C131.3,129.7,133.6,124.8,132,120.5z M125.6,127.5c-2.3,0.8-4.8-0.4-5.6-2.6c-0.8-2.3,0.4-4.8,2.6-5.6c2.3-0.8,4.8,0.3,5.6,2.6 C129,124.1,127.9,126.6,125.6,127.5z"
            id="el_DfobBtBEf9"
          />
          <path
            d="M170.4,106.9c-1.6-4.4-6.4-6.6-10.8-5c-4.4,1.6-6.6,6.4-5,10.8c1.6,4.4,6.4,6.6,10.8,5 C169.7,116.1,171.9,111.2,170.4,106.9z M164,113.9c-2.3,0.8-4.8-0.4-5.6-2.6c-0.8-2.3,0.4-4.8,2.6-5.6c2.3-0.8,4.8,0.3,5.6,2.6 C167.4,110.5,166.3,113,164,113.9z"
            id="el_08njgYNQLy"
          />
          <path
            d="M93.6,134.9c-1.6-4.4-6.4-6.6-10.8-5c-4.4,1.6-6.6,6.4-5,10.8c1.6,4.4,6.4,6.6,10.8,5 C92.9,144,95.2,139.2,93.6,134.9z M87.2,141.9c-2.3,0.8-4.8-0.4-5.6-2.6c-0.8-2.3,0.4-4.8,2.6-5.6c2.3-0.8,4.8,0.3,5.6,2.6 C90.7,138.5,89.5,141,87.2,141.9z"
            id="el_0PH24rdpBe"
          />
          <path
            d="M55.2,148.5c-1.6-4.4-6.4-6.6-10.8-5c-4.4,1.6-6.6,6.4-5,10.8c1.6,4.4,6.4,6.6,10.8,5 C54.6,157.6,56.8,152.8,55.2,148.5z M48.8,155.5c-2.3,0.8-4.8-0.3-5.6-2.6c-0.8-2.3,0.3-4.8,2.6-5.6c2.3-0.8,4.8,0.3,5.6,2.6 C52.3,152.1,51.1,154.6,48.8,155.5z"
            id="el_3yl9NfWHQ0"
          />
        </g>
        <g id="el_Q1y0Mpjw1HR">
          <path
            d="M153.7,167.1c-2.3-4-7.5-5.4-11.5-3.1c-4,2.3-5.4,7.5-3.1,11.5c2.3,4,7.5,5.4,11.5,3.1 C154.7,176.3,156.1,171.1,153.7,167.1z M148.7,175.1c-2.1,1.2-4.8,0.5-6-1.6c-1.2-2.1-0.5-4.8,1.6-6c2.1-1.2,4.8-0.5,6,1.6 C151.5,171.2,150.8,173.9,148.7,175.1z"
            id="el_05kFatetoHO"
          />
          <path
            d="M188.9,147.1c-2.3-4-7.5-5.4-11.5-3.1c-4,2.3-5.4,7.5-3.1,11.5c2.3,4,7.5,5.4,11.5,3.1 C189.9,156.3,191.2,151.2,188.9,147.1z M183.9,155.1c-2.1,1.2-4.8,0.5-6-1.6c-1.2-2.1-0.5-4.8,1.6-6c2.1-1.2,4.8-0.5,6,1.6 C186.7,151.2,186,153.9,183.9,155.1z"
            id="el_c9zQVp7vrsP"
          />
          <path
            d="M118.6,187.9c-2.3-4-7.5-5.4-11.5-3.1c-4,2.3-5.4,7.5-3.1,11.5c2.3,4,7.5,5.4,11.5,3.1 C119.5,197.1,120.9,191.9,118.6,187.9z M113.5,195.9c-2.1,1.2-4.8,0.5-6-1.6c-1.2-2.1-0.5-4.8,1.6-6s4.8-0.5,6,1.6 S115.6,194.7,113.5,195.9z"
            id="el_uwnON0vpuqH"
          />
          <path
            d="M83.4,207.9c-2.3-4-7.5-5.4-11.5-3.1c-4,2.3-5.4,7.5-3.1,11.5c2.3,4,7.5,5.4,11.5,3.1 C84.3,217.1,85.7,211.9,83.4,207.9z M78.3,215.9c-2.1,1.2-4.8,0.5-6-1.6c-1.2-2.1-0.5-4.8,1.6-6c2.1-1.2,4.8-0.5,6,1.6 C81.1,212,80.4,214.7,78.3,215.9z"
            id="el_VzWu6OVhy9Z"
          />
        </g>
        <g id="el_pWWQGhAiDr5">
          <path
            d="M183.3,209.9c-3-3.6-8.3-4-11.8-1c-3.6,3-4,8.3-1,11.8c3,3.6,8.3,4,11.8,1 C185.8,218.8,186.3,213.5,183.3,209.9z M179.7,218.7c-1.9,1.6-4.6,1.3-6.2-0.5c-1.6-1.9-1.3-4.6,0.5-6.2c1.9-1.6,4.6-1.3,6.2,0.5 C181.8,214.3,181.5,217.1,179.7,218.7z"
            id="el_Pw6JNw5UaKN"
          />
          <path
            d="M214.5,183.5c-3-3.6-8.3-4-11.8-1c-3.6,3-4,8.3-1,11.8c3,3.6,8.3,4,11.8,1C217,192.4,217.5,187.1,214.5,183.5z M210.9,192.3c-1.9,1.6-4.6,1.3-6.2-0.5c-1.6-1.9-1.3-4.6,0.5-6.2c1.9-1.6,4.6-1.3,6.2,0.5C213,187.9,212.7,190.7,210.9,192.3z"
            id="el_rh_iVV52hvM"
          />
          <path
            d="M152.1,236.3c-3-3.6-8.3-4-11.8-1c-3.6,3-4,8.3-1,11.8c3,3.6,8.3,4,11.8,1 C154.6,245.1,155.1,239.8,152.1,236.3z M148.5,245.1c-1.9,1.6-4.6,1.3-6.2-0.5c-1.6-1.9-1.3-4.6,0.5-6.2c1.9-1.6,4.6-1.3,6.2,0.5 C150.6,240.7,150.4,243.5,148.5,245.1z"
            id="el_SFT6u_AabW-"
          />
          <path
            d="M120.9,261.9c-3-3.6-8.3-4-11.8-1c-3.6,3-4,8.3-1,11.8c3,3.6,8.3,4,11.8,1 C123.4,270.7,123.9,265.4,120.9,261.9z M117.3,270.6c-1.9,1.6-4.6,1.3-6.2-0.5c-1.6-1.9-1.3-4.6,0.5-6.2c1.9-1.6,4.6-1.3,6.2,0.5 C119.4,266.3,119.2,269.1,117.3,270.6z"
            id="el_OQ9kJTc8a3c"
          />
        </g>
        <g id="el_vFy43RLBRC4">
          <path
            d="M219.8,246.5c-3.6-3-8.9-2.5-11.8,1c-3,3.6-2.5,8.8,1,11.8c3.5,3,8.9,2.5,11.8-1 C223.9,254.7,223.4,249.4,219.8,246.5z M217.8,255.7c-1.6,1.9-4.3,2.1-6.2,0.5c-1.9-1.6-2.1-4.3-0.5-6.2c1.6-1.9,4.3-2.1,6.2-0.5 C219.1,251.1,219.4,253.8,217.8,255.7z"
            id="el_KebrT7vPDSq"
          />
          <path
            d="M246.2,215.3c-3.6-3-8.9-2.5-11.8,1c-3,3.6-2.5,8.8,1,11.8c3.5,3,8.9,2.5,11.8-1 C250.2,223.5,249.8,218.2,246.2,215.3z M244.2,224.5c-1.6,1.9-4.3,2.1-6.2,0.5c-1.9-1.6-2.1-4.3-0.5-6.2c1.6-1.9,4.3-2.1,6.2-0.5 C245.5,219.9,245.8,222.7,244.2,224.5z"
            id="el_Nl7MPzofApJ"
          />
          <path
            d="M194.3,277.6c-3.6-3-8.8-2.5-11.8,1c-3,3.6-2.5,8.8,1,11.8c3.6,3,8.8,2.5,11.8-1 C198.3,285.9,197.8,280.6,194.3,277.6z M192.2,286.9c-1.6,1.9-4.3,2.1-6.2,0.5c-1.9-1.6-2.1-4.3-0.5-6.2c1.6-1.9,4.3-2.1,6.2-0.5 C193.5,282.3,193.8,285,192.2,286.9z"
            id="el_QNBsnXS-9MN"
          />
          <path
            d="M167.9,308.8c-3.6-3-8.8-2.5-11.8,1c-3,3.6-2.5,8.9,1,11.8c3.6,3,8.8,2.5,11.8-1 C171.9,317.1,171.4,311.8,167.9,308.8z M165.8,318.1c-1.6,1.9-4.3,2.1-6.2,0.5c-1.9-1.6-2.1-4.3-0.5-6.2c1.6-1.9,4.3-2.1,6.2-0.5 C167.2,313.4,167.4,316.2,165.8,318.1z"
            id="el_UW58TrQjNUB"
          />
        </g>
        <g id="el_CjIte0xzZl5">
          <path
            d="M262.6,276c-4-2.3-9.2-0.9-11.5,3.1c-2.3,4-0.9,9.2,3.1,11.5c4,2.3,9.2,0.9,11.5-3.1 C268,283.4,266.6,278.3,262.6,276z M262.2,285.5c-1.2,2.1-3.9,2.8-6,1.6c-2.1-1.2-2.8-3.9-1.6-6c1.2-2.1,3.9-2.8,6-1.6 C262.7,280.7,263.4,283.4,262.2,285.5z"
            id="el_V1XKDCs7Y1w"
          />
          <path
            d="M282.6,240.8c-4-2.3-9.2-0.9-11.5,3.1c-2.3,4-0.9,9.1,3.1,11.5c4,2.3,9.1,0.9,11.5-3.1 C288,248.3,286.6,243.1,282.6,240.8z M282.2,250.3c-1.2,2.1-3.9,2.8-6,1.6c-2.1-1.2-2.8-3.9-1.6-6c1.2-2.1,3.9-2.8,6-1.6 C282.7,245.5,283.4,248.2,282.2,250.3z"
            id="el_sppwRz2Vw3n"
          />
          <path
            d="M241.8,311.2c-4-2.3-9.1-0.9-11.5,3.1c-2.3,4-0.9,9.1,3.1,11.5c4,2.3,9.2,0.9,11.5-3.1 C247.2,318.6,245.8,313.5,241.8,311.2z M241.4,320.6c-1.2,2.1-3.9,2.8-6,1.6c-2.1-1.2-2.8-3.9-1.6-6c1.2-2.1,3.9-2.8,6-1.6 C241.9,315.9,242.6,318.5,241.4,320.6z"
            id="el_r9eX6krpCnm"
          />
          <path
            d="M208.3,346.4c-4-2.3-9.2-0.9-11.5,3.1c-2.3,4-0.9,9.2,3.1,11.5c4,2.3,9.2,0.9,11.5-3.1 C213.7,353.8,212.3,348.7,208.3,346.4z M207.9,355.8c-1.2,2.1-3.9,2.8-6,1.6c-2.1-1.2-2.8-3.9-1.6-6c1.2-2.1,3.9-2.8,6-1.6 C208.4,351,209.2,353.7,207.9,355.8z"
            id="el_Bh5f82mbhhK"
          />
        </g>
        <g id="el_pps5G3oW8Dp">
          <path
            d="M309.3,297.8c-4.4-1.6-9.2,0.7-10.8,5c-1.6,4.4,0.7,9.2,5,10.8c4.4,1.6,9.2-0.7,10.8-5 C315.9,304.2,313.6,299.4,309.3,297.8z M310.5,307.2c-0.8,2.3-3.4,3.5-5.6,2.6c-2.3-0.8-3.5-3.4-2.6-5.6c0.8-2.3,3.4-3.5,5.6-2.6 C310.2,302.4,311.4,304.9,310.5,307.2z"
            id="el_6nzqrJXYm6_"
          />
          <path
            d="M323.7,259.4c-4.4-1.6-9.2,0.7-10.8,5c-1.6,4.4,0.7,9.2,5,10.8c4.4,1.6,9.2-0.7,10.8-5 C330.3,265.8,328,261,323.7,259.4z M324.9,268.8c-0.8,2.3-3.4,3.5-5.6,2.6c-2.3-0.8-3.5-3.4-2.6-5.6c0.8-2.3,3.4-3.5,5.6-2.6 C324.6,264,325.7,266.5,324.9,268.8z"
            id="el_EXmoVUjJthl"
          />
          <path
            d="M295.7,336.1c-4.4-1.6-9.2,0.7-10.8,5c-1.6,4.4,0.7,9.2,5,10.8c4.4,1.6,9.2-0.7,10.8-5 C302.3,342.6,300,337.7,295.7,336.1z M296.9,345.5c-0.8,2.3-3.4,3.5-5.6,2.6c-2.3-0.8-3.5-3.4-2.6-5.6c0.8-2.3,3.4-3.5,5.6-2.6 C296.6,340.7,297.8,343.3,296.9,345.5z"
            id="el_owlFqmqCm-5"
          />
          <path
            d="M281.3,374.5c-4.4-1.6-9.2,0.7-10.8,5c-1.6,4.4,0.7,9.2,5,10.8c4.4,1.6,9.2-0.7,10.8-5 C287.9,380.9,285.6,376.1,281.3,374.5z M282.5,383.9c-0.8,2.3-3.3,3.5-5.6,2.6c-2.3-0.8-3.5-3.4-2.6-5.6c0.8-2.3,3.4-3.5,5.6-2.6 C282.2,379.1,283.4,381.6,282.5,383.9z"
            id="el_qCXjfTIqryw"
          />
        </g>
        <g id="el_-ugChuB7G9E">
          <path
            d="M359,311c-4.6-0.8-8.9,2.2-9.7,6.8c-0.8,4.6,2.2,8.9,6.8,9.7c4.6,0.8,8.9-2.2,9.7-6.8 C366.6,316.1,363.6,311.8,359,311z M361.9,320c-0.4,2.4-2.7,4-5.1,3.6c-2.4-0.4-4-2.7-3.6-5.1c0.4-2.4,2.7-4,5.1-3.6 C360.7,315.3,362.3,317.6,361.9,320z"
            id="el_BxvkUEQQDcy"
          />
          <path
            d="M366.2,271c-4.6-0.8-8.9,2.2-9.7,6.8c-0.8,4.6,2.2,8.9,6.8,9.7c4.6,0.8,8.9-2.2,9.7-6.8 C373.8,276.2,370.8,271.8,366.2,271z M369.1,280c-0.4,2.4-2.7,4-5.1,3.6c-2.4-0.4-4-2.7-3.6-5.1c0.4-2.4,2.7-4,5.1-3.6 C367.9,275.4,369.5,277.6,369.1,280z"
            id="el_HBKdZifKVkK"
          />
          <path
            d="M352.6,351.8c-4.6-0.8-8.9,2.2-9.7,6.8c-0.8,4.6,2.2,8.9,6.8,9.7c4.6,0.8,8.9-2.2,9.7-6.8 C360.2,356.9,357.2,352.6,352.6,351.8z M355.5,360.8c-0.4,2.4-2.7,4-5.1,3.6c-2.4-0.4-4-2.7-3.6-5.1c0.4-2.4,2.7-4,5.1-3.6 C354.3,356.1,355.9,358.4,355.5,360.8z"
            id="el_Vagk-9u-CHZ"
          />
          <path
            d="M345.4,391.7c-4.6-0.8-8.9,2.2-9.7,6.8c-0.8,4.6,2.2,8.9,6.8,9.7c4.6,0.8,8.9-2.2,9.7-6.8 C353,396.9,350,392.5,345.4,391.7z M348.3,400.8c-0.4,2.4-2.7,4-5.1,3.6c-2.4-0.4-4-2.7-3.6-5.1c0.4-2.4,2.7-4,5.1-3.6 C347.1,396.1,348.7,398.4,348.3,400.8z"
            id="el_QNiNDq9JdJ5"
          />
        </g>
        <g id="el_GGQN3_BuYi5">
          <path
            d="M411.1,315.6c-4.6,0-8.4,3.8-8.4,8.4c0,4.6,3.8,8.4,8.4,8.4c4.6,0,8.4-3.8,8.4-8.4 C419.5,319.4,415.8,315.6,411.1,315.6z M411.1,328.4c-2.4,0-4.4-2-4.4-4.4c0-2.4,2-4.4,4.4-4.4c2.4,0,4.4,2,4.4,4.4 C415.5,326.5,413.6,328.4,411.1,328.4z"
            id="el_6NXBid1Dhgd"
          />
          <path
            d="M411.1,274.9c-4.6,0-8.4,3.8-8.4,8.4c0,4.6,3.8,8.4,8.4,8.4c4.6,0,8.4-3.8,8.4-8.4 C419.5,278.6,415.8,274.9,411.1,274.9z M411.1,287.7c-2.4,0-4.4-2-4.4-4.4c0-2.4,2-4.4,4.4-4.4c2.4,0,4.4,2,4.4,4.4 C415.5,285.7,413.6,287.7,411.1,287.7z"
            id="el_ppui91L-U9j"
          />
          <path
            d="M411.1,356.4c-4.6,0-8.4,3.8-8.4,8.4c0,4.6,3.8,8.4,8.4,8.4c4.6,0,8.4-3.8,8.4-8.4 C419.5,360.2,415.8,356.4,411.1,356.4z M411.1,369.2c-2.4,0-4.4-2-4.4-4.4c0-2.4,2-4.4,4.4-4.4c2.4,0,4.4,2,4.4,4.4 C415.5,367.3,413.6,369.2,411.1,369.2z"
            id="el_hxaLYRwU7uL"
          />
          <path
            d="M411.1,397.2c-4.6,0-8.4,3.8-8.4,8.4c0,4.6,3.8,8.4,8.4,8.4c4.6,0,8.4-3.8,8.4-8.4 C419.5,401,415.8,397.2,411.1,397.2z M411.1,410c-2.4,0-4.4-2-4.4-4.4c0-2.4,2-4.4,4.4-4.4c2.4,0,4.4,2,4.4,4.4 C415.5,408,413.6,410,411.1,410z"
            id="el_ZjHfVGfJ4SQ"
          />
        </g>
        <g id="el_vdpgPd2MrFF">
          <path
            d="M486.6,398.5c-0.8-4.6-5.2-7.6-9.7-6.8c-4.6,0.8-7.6,5.2-6.8,9.7c0.8,4.6,5.2,7.6,9.7,6.8 C484.3,407.5,487.4,403.1,486.6,398.5z M479.1,404.3c-2.4,0.4-4.7-1.2-5.1-3.6c-0.4-2.4,1.2-4.7,3.6-5.1c2.4-0.4,4.7,1.2,5.1,3.6 C483.1,401.6,481.5,403.9,479.1,404.3z"
            id="el_nQHGPd09Y34"
          />
          <path
            d="M472.2,317.8c-0.8-4.6-5.2-7.6-9.7-6.8c-4.6,0.8-7.6,5.2-6.8,9.7c0.8,4.6,5.2,7.6,9.7,6.8 C469.9,326.7,473,322.4,472.2,317.8z M464.7,323.6c-2.4,0.4-4.7-1.2-5.1-3.6c-0.4-2.4,1.2-4.7,3.6-5.1c2.4-0.4,4.7,1.2,5.1,3.6 C468.7,320.9,467.1,323.2,464.7,323.6z"
            id="el_o4nSIhJdezA"
          />
          <path
            d="M479.4,358.6c-0.8-4.6-5.2-7.6-9.7-6.8c-4.6,0.8-7.6,5.2-6.8,9.7c0.8,4.6,5.2,7.6,9.7,6.8 C477.1,367.5,480.2,363.1,479.4,358.6z M471.9,364.4c-2.4,0.4-4.7-1.2-5.1-3.6c-0.4-2.4,1.2-4.7,3.6-5.1c2.4-0.4,4.7,1.2,5.1,3.6 C475.9,361.7,474.3,363.9,471.9,364.4z"
            id="el_53IxYoalfe6"
          />
          <path
            d="M465,277.8c-0.8-4.6-5.2-7.6-9.7-6.8c-4.6,0.8-7.6,5.2-6.8,9.7c0.8,4.6,5.2,7.6,9.7,6.8 C462.7,286.7,465.8,282.4,465,277.8z M457.5,283.6c-2.4,0.4-4.7-1.2-5.1-3.6c-0.4-2.4,1.2-4.7,3.6-5.1c2.4-0.4,4.7,1.2,5.1,3.6 C461.5,280.9,459.9,283.2,457.5,283.6z"
            id="el_lv5mZDRJcmd"
          />
        </g>
        <g id="el_ciMkrvowX3d">
          <path
            d="M551,379.5c-1.6-4.4-6.4-6.6-10.8-5c-4.4,1.6-6.6,6.4-5,10.8c1.6,4.4,6.4,6.6,10.8,5 C550.3,388.7,552.5,383.9,551,379.5z M544.6,386.5c-2.3,0.8-4.8-0.3-5.6-2.6c-0.8-2.3,0.4-4.8,2.6-5.6c2.3-0.8,4.8,0.4,5.6,2.6 C548,383.2,546.9,385.7,544.6,386.5z"
            id="el_VBQonMOoH67"
          />
          <path
            d="M523,302.8c-1.6-4.4-6.4-6.6-10.8-5c-4.4,1.6-6.6,6.4-5,10.8c1.6,4.4,6.4,6.6,10.8,5 C522.3,312,524.6,307.1,523,302.8z M516.6,309.8c-2.3,0.8-4.8-0.3-5.6-2.6c-0.8-2.3,0.4-4.8,2.6-5.6c2.3-0.8,4.8,0.4,5.6,2.6 C520,306.4,518.9,309,516.6,309.8z"
            id="el_ZLmcW48Cotn"
          />
          <path
            d="M537.4,341.2c-1.6-4.4-6.4-6.6-10.8-5c-4.4,1.6-6.6,6.4-5,10.8c1.6,4.4,6.4,6.6,10.8,5 C536.7,350.3,539,345.5,537.4,341.2z M531,348.2c-2.3,0.8-4.8-0.3-5.6-2.6c-0.8-2.3,0.4-4.8,2.6-5.6c2.3-0.8,4.8,0.4,5.6,2.6 C534.4,344.8,533.3,347.3,531,348.2z"
            id="el_LR3FmyeloCK"
          />
          <path
            d="M509.4,264.4c-1.6-4.4-6.4-6.6-10.8-5c-4.4,1.6-6.6,6.4-5,10.8c1.6,4.4,6.4,6.6,10.8,5 C508.7,273.6,511,268.8,509.4,264.4z M503,271.4c-2.3,0.8-4.8-0.3-5.6-2.6c-0.8-2.3,0.3-4.8,2.6-5.6c2.3-0.8,4.8,0.3,5.6,2.6 C506.5,268.1,505.3,270.6,503,271.4z"
            id="el_n__IR7h8ue9"
          />
        </g>
        <g id="el_-HQKXn1BVqD">
          <path
            d="M611.1,349.4c-2.3-4-7.5-5.4-11.5-3.1c-4,2.3-5.4,7.5-3.1,11.5c2.3,4,7.5,5.4,11.5,3.1 C612.1,358.6,613.4,353.4,611.1,349.4z M606,357.4c-2.1,1.2-4.8,0.5-6-1.6c-1.2-2.1-0.5-4.8,1.6-6s4.8-0.5,6,1.6 C608.9,353.5,608.1,356.2,606,357.4z"
            id="el_dd6wgjE--m9"
          />
          <path
            d="M570.3,279.1c-2.3-4-7.5-5.4-11.5-3.1c-4,2.3-5.4,7.5-3.1,11.5c2.3,4,7.5,5.4,11.5,3.1 C571.3,288.2,572.7,283.1,570.3,279.1z M565.3,287.1c-2.1,1.2-4.8,0.5-6-1.6c-1.2-2.1-0.5-4.8,1.6-6c2.1-1.2,4.8-0.5,6,1.6 C568.1,283.2,567.4,285.9,565.3,287.1z"
            id="el_Fa33R_nQrct"
          />
          <path
            d="M591.1,314.3c-2.3-4-7.5-5.4-11.5-3.1c-4,2.3-5.4,7.5-3.1,11.5c2.3,4,7.5,5.4,11.5,3.1 C592.1,323.4,593.4,318.3,591.1,314.3z M586.1,322.3c-2.1,1.2-4.8,0.5-6-1.6c-1.2-2.1-0.5-4.8,1.6-6c2.1-1.2,4.8-0.5,6,1.6 C588.9,318.4,588.2,321,586.1,322.3z"
            id="el_-PDbKUzL7pi"
          />
          <path
            d="M550.3,243.9c-2.3-4-7.5-5.4-11.5-3.1c-4,2.3-5.4,7.5-3.1,11.5c2.3,4,7.5,5.4,11.5,3.1 C551.3,253,552.7,247.9,550.3,243.9z M545.3,251.9c-2.1,1.2-4.8,0.5-6-1.6c-1.2-2.1-0.5-4.8,1.6-6c2.1-1.2,4.8-0.5,6,1.6 C548.1,248,547.4,250.7,545.3,251.9z"
            id="el_4H7NClsm_iX"
          />
        </g>
        <g id="el_GIYiIF7iIse">
          <path
            d="M665.4,309.9c-3-3.6-8.3-4-11.8-1c-3.6,3-4,8.3-1,11.8c3,3.5,8.3,4,11.8,1C668,318.7,668.4,313.4,665.4,309.9z M661.8,318.6c-1.9,1.6-4.6,1.3-6.2-0.5c-1.6-1.9-1.3-4.6,0.5-6.2c1.9-1.6,4.6-1.3,6.2,0.6C663.9,314.3,663.7,317.1,661.8,318.6z"
            id="el_y9ccQ7qwds_"
          />
          <path
            d="M613.5,247.5c-3-3.6-8.3-4-11.8-1c-3.6,3-4,8.3-1,11.8c3,3.5,8.3,4,11.8,1C616,256.3,616.5,251,613.5,247.5z M609.9,256.2c-1.9,1.6-4.6,1.3-6.2-0.5c-1.6-1.9-1.3-4.6,0.5-6.2c1.9-1.6,4.6-1.3,6.2,0.5C612,251.9,611.7,254.7,609.9,256.2z"
            id="el_TAxKOOZYl3Q"
          />
          <path
            d="M639.9,278.7c-3-3.6-8.3-4-11.8-1c-3.6,3-4,8.3-1,11.8c3,3.5,8.3,4,11.8,1 C642.4,287.5,642.8,282.2,639.9,278.7z M636.3,287.4c-1.9,1.6-4.6,1.3-6.2-0.5c-1.6-1.9-1.3-4.6,0.5-6.2c1.9-1.6,4.6-1.3,6.2,0.5 C638.4,283.1,638.1,285.9,636.3,287.4z"
            id="el_MOuUkeVja9v"
          />
          <path
            d="M587.1,216.3c-3-3.6-8.3-4-11.8-1c-3.6,3-4,8.3-1,11.8c3,3.5,8.3,4,11.8,1 C589.6,225.1,590.1,219.9,587.1,216.3z M583.5,225.1c-1.9,1.6-4.6,1.3-6.2-0.5c-1.6-1.9-1.3-4.6,0.5-6.2c1.9-1.6,4.6-1.3,6.2,0.5 C585.6,220.7,585.3,223.5,583.5,225.1z"
            id="el_C8D2acPIqzZ"
          />
        </g>
        <g id="el_M4JKcPN5muE">
          <path
            d="M712.4,260.8c-3.6-3-8.8-2.5-11.8,1c-3,3.6-2.5,8.9,1,11.8c3.5,3,8.8,2.5,11.8-1 C716.4,269.1,715.9,263.8,712.4,260.8z M710.4,270.1c-1.6,1.9-4.3,2.1-6.2,0.5c-1.9-1.6-2.1-4.3-0.5-6.2c1.6-1.9,4.3-2.1,6.2-0.5 C711.7,265.5,711.9,268.2,710.4,270.1z"
            id="el_pWfYtK_vB-p"
          />
          <path
            d="M650,208.9c-3.6-3-8.8-2.5-11.8,1c-3,3.6-2.5,8.8,1,11.8c3.5,3,8.8,2.5,11.8-1 C654,217.1,653.6,211.8,650,208.9z M648,218.1c-1.6,1.9-4.3,2.1-6.2,0.5c-1.9-1.6-2.1-4.3-0.5-6.2c1.6-1.9,4.3-2.1,6.2-0.5 C649.3,213.5,649.6,216.3,648,218.1z"
            id="el_pyzhoQ8dwKj"
          />
          <path
            d="M681.2,235.3c-3.6-3-8.8-2.5-11.8,1c-3,3.5-2.5,8.9,1,11.8c3.5,3,8.8,2.5,11.8-1 C685.2,243.5,684.8,238.2,681.2,235.3z M679.2,244.5c-1.6,1.9-4.3,2.1-6.2,0.5c-1.9-1.6-2.1-4.3-0.5-6.2c1.6-1.9,4.3-2.1,6.2-0.5 C680.5,239.9,680.7,242.7,679.2,244.5z"
            id="el_eMews-3FU20"
          />
          <path
            d="M618.8,182.5c-3.6-3-8.8-2.5-11.8,1c-3,3.6-2.5,8.8,1,11.8c3.5,3,8.8,2.5,11.8-1 C622.9,190.8,622.4,185.5,618.8,182.5z M616.8,191.7c-1.6,1.9-4.3,2.1-6.2,0.5c-1.9-1.6-2.1-4.3-0.5-6.2c1.6-1.9,4.3-2.1,6.2-0.5 C618.1,187.1,618.4,189.9,616.8,191.7z"
            id="el_XsP2I8GNRmR"
          />
        </g>
        <g id="el_ePehtqZKkF2">
          <path
            d="M749.6,204.8c-4-2.3-9.2-0.9-11.5,3.1c-2.3,4-0.9,9.2,3.1,11.5c4,2.3,9.2,0.9,11.5-3.1 C755,212.3,753.6,207.1,749.6,204.8z M749.2,214.3c-1.2,2.1-3.9,2.8-6,1.6c-2.1-1.2-2.8-3.9-1.6-6c1.2-2.1,3.9-2.8,6-1.6 C749.7,209.5,750.4,212.2,749.2,214.3z"
            id="el_rYcgw868u70"
          />
          <path
            d="M679.2,164.1c-4-2.3-9.2-0.9-11.5,3.1c-2.3,4-0.9,9.2,3.1,11.5c4,2.3,9.2,0.9,11.5-3.1 C684.6,171.5,683.2,166.4,679.2,164.1z M678.8,173.5c-1.2,2.1-3.9,2.8-6,1.6c-2.1-1.2-2.8-3.9-1.6-6c1.2-2.1,3.9-2.8,6-1.6 C679.3,168.7,680,171.4,678.8,173.5z"
            id="el_ic8mx7njq-r"
          />
          <path
            d="M714.4,184.8c-4-2.3-9.2-0.9-11.5,3.1c-2.3,4-0.9,9.1,3.1,11.5c4,2.3,9.2,0.9,11.5-3.1 C719.8,192.3,718.4,187.2,714.4,184.8z M714,194.3c-1.2,2.1-3.9,2.8-6,1.6c-2.1-1.2-2.8-3.9-1.6-6s3.9-2.8,6-1.6 S715.2,192.2,714,194.3z"
            id="el_TD1oYgAx3v6"
          />
          <path
            d="M644,144.1c-4-2.3-9.2-0.9-11.5,3.1c-2.3,4-0.9,9.2,3.1,11.5c4,2.3,9.2,0.9,11.5-3.1 C649.4,151.5,648,146.4,644,144.1z M643.6,153.5c-1.2,2.1-3.9,2.8-6,1.6c-2.1-1.2-2.8-3.9-1.6-6c1.2-2.1,3.9-2.8,6-1.6 C644.1,148.7,644.8,151.4,643.6,153.5z"
            id="el_BCtHBLq0YRS"
          />
        </g>
        <g id="el_djkdAkKoWjd">
          <path
            d="M777,143.4c-4.4-1.6-9.2,0.7-10.8,5c-1.6,4.4,0.7,9.2,5,10.8c4.4,1.6,9.2-0.7,10.8-5 C783.6,149.9,781.4,145,777,143.4z M778.3,152.8c-0.8,2.3-3.3,3.5-5.6,2.6c-2.3-0.8-3.5-3.3-2.6-5.6c0.8-2.3,3.4-3.5,5.6-2.6 C777.9,148,779.1,150.6,778.3,152.8z"
            id="el_wGjLLFdaFPo"
          />
          <path
            d="M700.3,115.5c-4.4-1.6-9.2,0.7-10.8,5c-1.6,4.4,0.7,9.2,5,10.8c4.4,1.6,9.2-0.7,10.8-5 C706.9,121.9,704.6,117,700.3,115.5z M701.5,124.8c-0.8,2.3-3.4,3.5-5.6,2.6c-2.3-0.8-3.5-3.4-2.6-5.6c0.8-2.3,3.4-3.5,5.6-2.6 S702.4,122.6,701.5,124.8z"
            id="el_MXZjAlvGuBh"
          />
          <path
            d="M738.6,129.9c-4.4-1.6-9.2,0.7-10.8,5c-1.6,4.4,0.7,9.2,5,10.8c4.4,1.6,9.2-0.7,10.8-5 C745.2,136.3,743,131.4,738.6,129.9z M739.9,139.2c-0.8,2.3-3.3,3.5-5.6,2.6c-2.3-0.8-3.5-3.3-2.6-5.6c0.8-2.3,3.4-3.5,5.6-2.6 C739.6,134.4,740.7,137,739.9,139.2z"
            id="el_2mM6E_cKkIk"
          />
          <path
            d="M661.9,101.9c-4.4-1.6-9.2,0.7-10.8,5c-1.6,4.4,0.7,9.2,5,10.8c4.4,1.6,9.2-0.7,10.8-5 C668.5,108.3,666.2,103.4,661.9,101.9z M663.1,111.3c-0.8,2.3-3.4,3.5-5.6,2.6c-2.3-0.8-3.5-3.4-2.6-5.6c0.8-2.3,3.4-3.5,5.6-2.6 C662.8,106.5,664,109,663.1,111.3z"
            id="el_Eg5eL87f3Gz"
          />
        </g>
        <g id="el_pXeEy60fNMO">
          <path
            d="M793.2,78.3c-4.6-0.8-8.9,2.2-9.7,6.8c-0.8,4.6,2.2,8.9,6.8,9.7c4.6,0.8,8.9-2.2,9.7-6.8 C800.8,83.5,797.8,79.1,793.2,78.3z M796.1,87.3c-0.4,2.4-2.7,4-5.1,3.6c-2.4-0.4-4-2.7-3.6-5.1c0.4-2.4,2.7-4,5.1-3.6 C794.9,82.7,796.5,84.9,796.1,87.3z"
            id="el_nreGhzvIBWT"
          />
          <path
            d="M712.4,63.9c-4.6-0.8-8.9,2.2-9.7,6.8c-0.8,4.6,2.2,8.9,6.8,9.7c4.6,0.8,8.9-2.2,9.7-6.8 C720.1,69.1,717,64.7,712.4,63.9z M715.3,72.9c-0.4,2.4-2.7,4-5.1,3.6c-2.4-0.4-4-2.7-3.6-5.1c0.4-2.4,2.7-4,5.1-3.6 C714.1,68.3,715.7,70.5,715.3,72.9z"
            id="el_ukIEkZwJskX"
          />
          <path
            d="M753.2,71.1c-4.6-0.8-8.9,2.2-9.7,6.8c-0.8,4.6,2.2,8.9,6.8,9.7c4.6,0.8,8.9-2.2,9.7-6.8 C760.8,76.3,757.8,71.9,753.2,71.1z M756.1,80.1c-0.4,2.4-2.7,4-5.1,3.6c-2.4-0.4-4-2.7-3.6-5.1c0.4-2.4,2.7-4,5.1-3.6 C754.9,75.5,756.5,77.7,756.1,80.1z"
            id="el_iG4vGgjgmRl"
          />
          <path
            d="M672.5,56.7c-4.6-0.8-8.9,2.2-9.7,6.8c-0.8,4.6,2.2,8.9,6.8,9.7c4.6,0.8,8.9-2.2,9.7-6.8 C680.1,61.9,677,57.5,672.5,56.7z M675.3,65.7c-0.4,2.4-2.7,4-5.1,3.6c-2.4-0.4-4-2.7-3.6-5.1c0.4-2.4,2.7-4,5.1-3.6 C674.2,61.1,675.8,63.4,675.3,65.7z"
            id="el_gPgCVIL9Ijy"
          />
        </g>
        <g id="el_F85Rcy7KKrN">
          <path
            d="M715.8,11c-4.6,0-8.4,3.8-8.4,8.4c0,4.6,3.8,8.4,8.4,8.4c4.6,0,8.4-3.8,8.4-8.4C724.2,14.8,720.4,11,715.8,11z M715.8,23.8c-2.4,0-4.4-2-4.4-4.4c0-2.4,2-4.4,4.4-4.4c2.4,0,4.4,2,4.4,4.4C720.2,21.8,718.2,23.8,715.8,23.8z"
            id="el_9k0qwqCrWTs"
          />
          <path
            d="M797.3,11c-4.6,0-8.4,3.8-8.4,8.4c0,4.6,3.8,8.4,8.4,8.4c4.6,0,8.4-3.8,8.4-8.4C805.7,14.8,802,11,797.3,11z M797.3,23.8c-2.4,0-4.4-2-4.4-4.4c0-2.4,2-4.4,4.4-4.4c2.4,0,4.4,2,4.4,4.4C801.7,21.8,799.8,23.8,797.3,23.8z"
            id="el_B5zhfNkTVew"
          />
          <path
            d="M756.6,11c-4.6,0-8.4,3.8-8.4,8.4c0,4.6,3.8,8.4,8.4,8.4c4.6,0,8.4-3.8,8.4-8.4C765,14.8,761.2,11,756.6,11z M756.6,23.8c-2.4,0-4.4-2-4.4-4.4c0-2.4,2-4.4,4.4-4.4c2.4,0,4.4,2,4.4,4.4C761,21.8,759,23.8,756.6,23.8z"
            id="el_2MQl81jm3s5"
          />
          <path
            d="M675,11c-4.6,0-8.4,3.8-8.4,8.4c0,4.6,3.8,8.4,8.4,8.4c4.6,0,8.4-3.8,8.4-8.4C683.4,14.8,679.6,11,675,11z M675,23.8c-2.4,0-4.4-2-4.4-4.4c0-2.4,2-4.4,4.4-4.4c2.4,0,4.4,2,4.4,4.4C679.4,21.8,677.4,23.8,675,23.8z"
            id="el_dXnYDrUfbGB"
          />
        </g>
      </svg>
    );
  }
}
